module.exports = __webpack_public_path__ + "static/media/dice.048f0bbf.png";